import styled from "style/styled-components";

const ListItemSeparator = styled.div`
  width: 100%;
  height: 2px;
  background: ${({ theme }) => theme.color.foreground.quaternary};
`;

export default ListItemSeparator;
